import { useMemo, useRef } from 'react';
import { formatFileSize } from './file';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';
import { observer } from 'mobx-react-lite';
import inputTypeStore from '../input-file/input-type';

function DocumentCard(props) {
  const { file, icon, progress, closeable, onClose, onButtonClick, supportKnowledge } = props;
  const { name, size } = file;
  const isUploaded = progress == 100;

  const containerRef = useRef(null);

  const fileSize = useMemo(() => formatFileSize(size), [size]);

  return (
    <div className="flex items-center gap-[8px]">
      <section
        ref={containerRef}
        className={[
          'relative',
          'group',
          'w-[176px]',
          'rounded-[8px] border',
          'py-[8px] px-[10px]',
          'flex gap-[8px]',
          'text-[12px] leading-snug',
          closeable ? 'hover:bg-[rgba(0,0,0,.03)]' : '',
          globalStore.isDark ? 'border-[rgba(255,255,255,.3)]' : 'border-[rgba(0,0,0,.1)]'
        ]}
      >
        <img className="size-32px rounded-8px" src={icon} />
        <section className="flex flex-col overflow-hidden">
          <span className="text-primary-opacity text-opacity-80 font-bold truncate">{name}</span>
          <span className="text-primary-opacity text-opacity-50">
            {isUploaded ? fileSize : `上传中... ${progress}%`}
          </span>
        </section>

        {!isUploaded && (
          <div className="absolute top-0 right-0 bottom-0 left-0 rounded-[10px] overflow-hidden">
            <div
              style={{
                // prettier-ignore
                width: (containerRef.current?.offsetWidth ?? 0) * (progress / 100),
                // prettier-ignore
                background: 'linear-gradient(270deg,rgba(146,145,145,0.12) 0%, rgba(255,255,255,0) 100%)',
              }}
              className="h-full"
            ></div>
          </div>
        )}

        <span
          className={[
            'absolute -top-[7px] -right-[7px] z-100',
            'rounded-full p-[6px]',
            'bg-black bg-opacity-70 hover:bg-opacity-80',
            'cursor-pointer',
            'hidden',
            { 'group-hover:inline': closeable },
          ]}
          onClick={() => onClose?.(file)}
        >
          <SVGPureIcon name="close-8" className="size-8px text-white" />
        </span>
      </section>

      {isUploaded && (Array.from(inputTypeStore.tempFile)?.length == 1) && !supportKnowledge && (
        <section className="flex flex-col gap-[6px]">
          <button
            className={[
              'px-[8px] h-22px rounded-[8px] text-[12px] leading-[22px]',
              globalStore.isDark
                ? 'bg-[#31313A] hover:bg-[#31313A] hover:bg-opacity-50 hover:text-opacity-70 text-white text-opacity-50'
                : 'bg-[rgba(0,0,0,0.03)] hover:bg-[rgba(0,0,0,0.03)] hover:text-opacity-70 text-black text-opacity-50',
            ]}
            onClick={() => {
              onButtonClick?.({ type: 'summary', prompt: '总结关键点' })
            }}
          >
            总结关键点
          </button>
          <button
            className={[
              'px-[8px] h-22px rounded-[8px] text-[12px] leading-[22px]',
              globalStore.isDark
                ? 'bg-[#31313A] hover:bg-[#31313A] hover:bg-opacity-50 hover:text-opacity-70 text-white text-opacity-50'
                : 'bg-[rgba(0,0,0,0.03)] hover:bg-[rgba(0,0,0,0.03)] hover:text-opacity-70 text-black text-opacity-50',
            ]}
            onClick={() =>
              onButtonClick?.({ type: 'generate-outline', prompt: '生成大纲' })
            }
          >
            生成大纲
          </button>
        </section>
      )}
    </div>
  );
}

export default observer(DocumentCard);
